// busbar_registry.js
export const busbar_registry = [
    {
        location_id: 2,
        location: "Basement",
        sensors: [
            {
                meter_id: 1940,
                sensor_name: "Main Meter",
            },
            {
                meter_id: 1941,
                sensor_name: "Incoming Panel",
            },
        ],
    },
    {
        location_id: 3,
        location: "Electrical Room",
        sensors: [
            {
                meter_id: 1950,
                sensor_name: "DG Busbar",
            },
        ],
    },
];